import customers from "./customers";
import users from "./users";
import services from "./services";
import programs from "./programs";
import subServices from "./subServices";
import auth from "./auth";
import formBuilder from "./formBuilder";
import tickets from "./tickets";
import memberBenefits from "./memberBenefits";
import categories from "./categories";
import commericals from "./commericals";
import blogs from "./blogs";
import clients from "./clients";
import membershipPlans from "./membershipPlans";
import productConfig from "./productConfig";
import vendorListMapping from "./vendorListMapping";
import subCategories from "./subCategories";
import CommunicationService from "./CommunicationService";
export default {
  customers,
  users,
  services,
  programs,
  subServices,
  auth,
  formBuilder,
  tickets,
  memberBenefits,
  categories,
  commericals,
  blogs,
  clients,
  membershipPlans,
  productConfig,
  vendorListMapping,
  subCategories,
  CommunicationService,
};
